export default __webpack_public_path__ + "static/media/SWT1710.34I-39170_-23039_0.7d17cf41.jpg";